import { Deserializable } from '../../protocols/deserializable';
import { Asset } from '../dto/asset';
import { MediaManagerFolderDto } from '../dto/media-manager-folder-dto';

// https://github.com/mobilefirstdev/budsense-image-service/blob/dev/models/BulkEditAssetsRequest.go
export class BulkEditAssetsRequest implements Deserializable {
  constructor(targetFolderId?: string, updateAssetFolders?: MediaManagerFolderDto[], updatedAssets?: Asset[]) {
    this.targetFolderId = targetFolderId ?? '';
    this.updatedAssetFolders = updateAssetFolders ?? [];
    this.updatedAssets = updatedAssets ?? [];
  }

  public targetFolderId: string = '';
  public updatedAssetFolders: MediaManagerFolderDto[] = [];
  public updatedAssets: Asset[] = [];

  onDeserialize(): void {
    const Deserialize = window?.injector?.Deserialize;
    this.updatedAssetFolders = Deserialize?.arrayOf(MediaManagerFolderDto, this.updatedAssetFolders) ?? [];
    this.updatedAssets = Deserialize?.arrayOf(Asset, this.updatedAssets) ?? [];
  }
}
